import React from 'react'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

// background-color should be neutral20
// fix me when modal colors are confirmed

export const Highlight = ({ children }) => {
  return (
    <span
      className={css`
        padding: 2px;
        border-radius: 3px;
        background-color: ${theme.color.neutral10};
        color: ${theme.color.red70};
      `}
    >
      {children}
    </span>
  )
}
